import { ajax } from "@/utils/request";

export default {
    /****************************************************************
     *
     *@老板看数
     *
     ***************************************************************/
    // 项目收支统计-列表
    getBossProjectStatisticsList: (data: any) => {
        return ajax({
            method: 'GET',
            url: `leader/project-statistics-list`,
            data
        })
    },
    // 项目收支统计-分页
    getBossProjectStatisticsPage: (data: any) => {
        return ajax({
            method: 'GET',
            url: `leader/project-statistics-page`,
            data
        })
    },
    // 班组支付统计
    getBossClassStatisticsList: (data: any) => {
        return ajax({
            method: 'GET',
            url: `leader/labour-statistics`,
            data
        })
    },
    // 供应商供应及支付统计
    getBossSupplierStatisticsList: (data: any) => {
        return ajax({
            method: 'GET',
            url: `leader/supplier-statistics`,
            data
        })
    },

};


